/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import vuetify from './vuetify'
import router from '../router'
import planosEmpresaPlugin from './planosEmpresa'
import sessionPlugin from './session'
import formatPugin from './format'
import TestPlugin from './test'
import ConfirmPlugin from './confirm'
import websocketPlugin from './websocket'
import { registerPrimeVue } from './primevue'
import { loadGoogleMapsScript } from '@/plugins/googlemaps.js'
import { registerNotivue } from '@/plugins/notivue.js'
import { registerPinia } from '@/plugins/pinia.js'
import { registerMisc } from '@/plugins/misc.js'

export function registerPlugins(app) {
  app
    .use(websocketPlugin)
    .use(vuetify)
    .use(planosEmpresaPlugin)
    // .use(sessionPlugin)
    .use(formatPugin)
    .use(TestPlugin)
    .use(ConfirmPlugin)
    .use(registerPrimeVue)
    .use(registerNotivue)
    .use(registerPinia)
    .use(loadGoogleMapsScript)
    .use(registerMisc)
}
